export default "__VITE_ASSET__d07d3241__"